import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import DateHeadersOptionState from '../store/schema/DateHeadersOptionState';
import store from '../store/store';
import OwaViewStateConfiguration from 'owa-service/lib/contract/OwaViewStateConfiguration';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';

export interface IsDateHeadersOptionDirtyState {
    optionState: DateHeadersOptionState;
    viewStateConfiguration: OwaViewStateConfiguration;
}

export default select<IsDateHeadersOptionDirtyState>({
    optionState: () => store,
    viewStateConfiguration: () => getUserConfiguration().ViewStateConfiguration,
})(function IsDateHeadersDirty(state?: IsDateHeadersOptionDirtyState) {
    return (
        state.optionState.isEnabled !== null &&
        state.optionState.isEnabled == getIsBitSet(ListViewBitFlagsMasks.DateHeadersDisabled)
    );
});
